/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface XmlToJson
 */
export interface XmlToJson {
  /**
   *
   * @type {string}
   * @memberof XmlToJson
   */
  json: string;
}

/**
 * Check if a given object implements the XmlToJson interface.
 */
export function instanceOfXmlToJson(value: object): value is XmlToJson {
  if (!("json" in value) || value["json"] === undefined) return false;
  return true;
}

export function XmlToJsonFromJSON(json: any): XmlToJson {
  return XmlToJsonFromJSONTyped(json, false);
}

export function XmlToJsonFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): XmlToJson {
  if (json == null) {
    return json;
  }
  return {
    json: json["json"],
  };
}

export function XmlToJsonToJSON(json: any): XmlToJson {
  return XmlToJsonToJSONTyped(json, false);
}

export function XmlToJsonToJSONTyped(
  value?: XmlToJson | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    json: value["json"],
  };
}
